<template>
  <div id="app container">
    <div class="row">
      <div class="col center">
          <img alt="Martine logo" src="./assets/main/logMartine.png">
      </div>
    </div>
    <div class="row">
      <div class="col">
            <Menu v-bind:cookieStatus="cookieStatus" />
      </div>
    </div>
  <!--<Cookie @statusUpdate="updateCookie"></Cookie>-->
  </div>
</template>

<script>
import Menu from './components/Menu'
//import Cookie from './components/Cookie'

export default {
  name: 'App',
  components: {
    'Menu':Menu
    //'Cookie':Cookie
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.center {
text-align: center;
}
</style>
